import React, { useState, useEffect } from 'react'
import styles from './styles.module.sass'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { useHistory, Link } from 'react-router-dom'
import Slider from 'react-slick/lib/slider'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeaderSubMenu from 'newComponents/HeaderSubMenu'
import { decodeStorage } from 'newFunctions/storageBase64'
import { useValidateAccount } from 'newHooks/useValidateAccount'

const TarjetaDescuento = ({ url, type, clase = 'tarjetaDes', texto1, texto2 }) => {
    return (
        <div className={styles[clase]}>
            {/* <img src={`${BASE_PATH}${SUB_DIRECTORY}${url}`} className={styles?.ico} /> */}
            {
                type === "1" ? 
                    <div className={styles?.opcion1}>
                        <p className={styles?.pNegro}>{texto1}</p>
                        <span className={styles?.pRojo}> {texto2}</span>
                    </div>
                :  type === "2" ?
                    <div className={styles?.opcion1}>
                        <p className={styles?.pRojo}>{texto1} </p>
                        <span className={styles?.pNegro}> {texto2}</span>
                    </div>
                : null
            }
        </div>
    )
}

const Accordion = (props) => {
    const {
        title,
        firstActive = false,
        children
    } = props

    const [ active, setActive ] = useState(firstActive)
    const toggleAccordion = () => {
        setActive(!active)
    }

    return(
        <dl className={styles?.accordion}>
            <dt onClick={toggleAccordion} className={active ? `${styles?.h2 } ${styles?.up}` : `${styles?.h2 } ${styles?.down}`}>{title}</dt>
            {active
                ?
                    <dd className={active === true ? `${styles?.contExcepciones} ${styles?.active}` : styles?.contExcepciones}>
                        {children}
                    </dd>
                : null
            }
        </dl>
    )
}

const SectionCards = (props) => {

    const {
        activeCard,
        setActiveCard,
        flow
    } = props

    const history = useHistory()
    // const sears_numero_internet = decodeStorage('sears_numero_internet')
    // const access_token = decodeStorage('access_token')
    // const [ isLogin, setIsLogin] = useState(true)

    const selectedCard = (typeCard) => {
        setActiveCard(typeCard)
    }

    const sendCard = () => {
        const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`
        // console.log('url: ',solicitaCredito)
        history.push(solicitaCredito)
    }

    const sendLogin = () => {
        const actualURL = window.location.href
        const solicitaCredito = `${BASE_PATH}login?redirect=${actualURL}`
        window.location.href = solicitaCredito
    }

     const sendRgister = () => {
        const actualURL = window.location.href
        const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`
        history.push(solicitaCredito)
    }

    // useEffect(() => {
    //     if(sears_numero_internet && access_token){
    //         setIsLogin(false)
    //     }
    // },[])

    return(
        <section className={`${styles?.sectionCard} ${styles?.contanierSection}`}>
            <h1>Beneficios de tu tarjeta sears</h1>
            <div className={styles?.contCards}>
                <div className={activeCard === 'gold' ? `${styles?.contentCard} ${styles?.selected}` : styles?.contentCard } onClick={() => selectedCard('gold')}>
                    <img src={`${BASE_PATH}${SUB_DIRECTORY}/img/tarjetaGold.png`} />
                    <p>Tarjeta Gold</p>
                </div>
                <div className={activeCard === 'black' ? `${styles?.contentCard} ${styles?.selected}` : styles?.contentCard } onClick={() => selectedCard('black')}>
                    <img src={`${BASE_PATH}${SUB_DIRECTORY}/img/tarjetaBlack.png`} />
                    <p>Tarjeta Black</p>
                </div>
            </div>
            <div>
                {flow !== 3 &&
                    <div className={`${styles?.btn} ${styles?.red}`} onClick={sendCard}>Solicítala hoy</div>
                }
                <br/>
                {flow === 1 &&
                    <div className={`${styles?.btn} ${styles?.white}`} onClick={sendLogin}>¿Ya la tienes? Inicia sesión</div>
                }
                {flow === 2 &&
                    <div className={`${styles?.btn} ${styles?.white}`} onClick={sendRgister}>¿Ya la tienes? Regístrala</div>
                }
            </div>
        </section>
    )
}

const SectionPromos = (props) => {

    const {
        activeCard
    } = props

    const history = useHistory()

    const sendCard = () => {
        const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}beneficios/landing`
        history.push(solicitaCredito)
    }

    const goldCard = [
        {url:"img/schedule.png", clase:"1", texto1:"Anualidad", texto2:"SIN COSTO"},
        {url:"img/recoger-tienda.png", clase:"2", texto1:"Paga tu tarjeta", texto2:"en la app o tienda"},
        {url:"img/shield-2.png", clase:"2", texto1:"Seguro Medicall Home", texto2:"contratación con cargo mensual"},
        { url:"img/descuento.png", clase:"2", texto1:"20% de descuento", texto2:"primera compra en tiendas físicas*" },
        {url:"img/suitcase.png", clase:"2", texto1:"Descuentos en viajes", texto2:"Hasta 25% de descuento en Hoteles Grupo Ostar"},
        {url:"img/insurance.png", clase:"2", texto1:"Seguro para auto", texto2:"contratación con cargo mensual (Autotal Inbursa)"},
        {url:"img/fork.png", clase:"2", texto1:"10% de descuento", texto2:"en restaurantes y pastelerías (Sanborns y Sanborns Café)"},
        {url:"img/dollar.png", clase:"2", texto1:"Puntos Sears", texto2:"en todas tus compras con Crédito Revolvente" },
        {url:"img/rate.png", clase:"2", texto1:"25 días para pagar sin interés", texto2:"después de tu fecha de corte"},
        {url:"img/credit-cards-payment.png", clase:"1", texto1:"Tarjetas adicionales", texto2:"SIN COSTO"},
        {url:"img/gift-3.png", clase:"2",  texto1:"Recibe 100 puntos Sears", texto2:"al activar tu tarjeta Sears"},
        {url:"img/icon-tarjeta-sears.png", clase:"2", texto1:"Puedes comprar en:", texto2:"Sears y Sanborns"}
    ]
    const blackCard = [
        {url:"img/recoger-tienda.png", clase:"2", texto1:"Paga tu tarjeta", texto2:"en la app o tienda"},
        {url:"img/schedule.png", clase:"1", texto1:"Anualidad", texto2:"SIN COSTO"},
        {url:"img/shield-2.png", clase:"2", texto1:"Seguro Medicall Home", texto2:"contratación con cargo mensual"},
        { url:"img/descuento.png", clase:"2", texto1:"20% de descuento", texto2:"primera compra en tiendas físicas*" },
        {url:"img/suitcase.png", clase:"2", texto1:"Descuentos en viajes", texto2:"Hasta 25% de descuento en Hoteles Grupo Ostar"},
        {url:"img/insurance.png", clase:"2", texto1:"Seguro para auto", texto2:"contratación con cargo mensual (Autotal Inbursa)"},
        {url:"img/fork.png", clase:"2", texto1:"10% de descuento", texto2:"en restaurantes y pastelerías (Sanborns y Sanborns Café)"},
        {url:"img/dollar.png", clase:"2", texto1:"Puntos Sears", texto2:"en todas tus compras con Crédito Revolvente" },
        {url:"img/rate.png", clase:"2", texto1:"25 días para pagar sin interés", texto2:"después de tu fecha de corte"},
        {url:"img/credit-cards-payment.png", clase:"1", texto1:"Tarjetas adicionales", texto2:"SIN COSTO"},
        {url:"img/gift-3.png", clase:"2",  texto1:"Recibe 100 puntos Sears", texto2:"al activar tu tarjeta Sears"},
        {url:"img/icon-tarjeta-sears.png", clase:"2", texto1:"Puedes comprar en:", texto2:"Sears y Sanborns"}
    ]

    const settings = {
        dots: false,
        className: styles?.promoSliders,
        autoplay: false,
        infinite: true,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 3,
        adaptiveHeight: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    autoplay: false,
                    infinite: true,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    const [activeData, setActiveData ] = useState(goldCard)
    useEffect(()=>{
        if(activeCard){
            if(activeCard === 'gold'){setActiveData(goldCard)}
            else if(activeCard === 'black'){setActiveData(blackCard)}
        }
    },[activeCard])

    return(
        <section className={`${styles?.sectionPromos} ${styles?.contanierSection}`}>
            <div className={styles?.cardPromos}>
                <div className={styles?.contIntPromos}>
                    <p className={styles?.title}>Beneficios y promociones</p>
                    <div className={styles?.contPromosSlider}>
                            {activeData
                                ? 
                                    <Slider {...settings}>
                                        {activeData.map((dataCard, index) => 
                                            <TarjetaDescuento 
                                                key={index} 
                                                url={dataCard?.url} 
                                                type={dataCard?.clase} 
                                                clase="tarjetaDesSlider"
                                                texto1={dataCard?.texto1} 
                                                texto2={dataCard?.texto2}
                                            />
                                        )}
                                    </Slider>
                                : null
                            }
                    </div>
                </div>
                <div>
                    <div className={`${styles?.linkBtn} ${styles?.red} ${styles?.right}`} onClick={sendCard}>Ver todas</div>
                </div>
            </div>
        </section>
    )
}

const SectionPromosOld = (props) => {

    const {
        activeCard
    } = props

    const history = useHistory()

    const sendCard = () => {
        const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}beneficios/landing`
        history.push(solicitaCredito)
    }

    const goldCard = [
        {url:"img/schedule.png", clase:"1", texto1:"Anualidad", texto2:"SIN COSTO"},
        {url:"img/recoger-tienda.png", clase:"2", texto1:"Paga tu tarjeta", texto2:"en la app o tienda"},
        {url:"img/shield-2.png", clase:"2", texto1:"Seguro Medicall Home", texto2:"contratación con cargo mensual"},
        { url:"img/descuento.png", clase:"2", texto1:"20% de descuento", texto2:"primera compra en tiendas físicas*" },
        {url:"img/suitcase.png", clase:"2", texto1:"Descuentos en viajes", texto2:"Hasta 25% de descuento en Hoteles Grupo Ostar"},
        {url:"img/insurance.png", clase:"2", texto1:"Seguro para auto", texto2:"contratación con cargo mensual (Autotal Inbursa)"},
        {url:"img/fork.png", clase:"2", texto1:"10% de descuento", texto2:"en restaurantes y pastelerías (Sanborns y Sanborns Café)"},
        {url:"img/dollar.png", clase:"2", texto1:"Puntos Sears", texto2:"en todas tus compras con Crédito Revolvente" },
        {url:"img/rate.png", clase:"2", texto1:"25 días para pagar sin interés", texto2:"después de tu fecha de corte"},
        {url:"img/credit-cards-payment.png", clase:"1", texto1:"Tarjetas adicionales", texto2:"SIN COSTO"},
        {url:"img/gift-3.png", clase:"2",  texto1:"Recibe 100 puntos Sears", texto2:"al activar tu tarjeta Sears"},
        {url:"img/icon-tarjeta-sears.png", clase:"2", texto1:"Puedes comprar en:", texto2:"Sears y Sanborns"}
    ]
    const blackCard = [
        {url:"img/recoger-tienda.png", clase:"2", texto1:"Paga tu tarjeta", texto2:"en la app o tienda"},
        {url:"img/schedule.png", clase:"1", texto1:"Anualidad", texto2:"SIN COSTO"},
        {url:"img/shield-2.png", clase:"2", texto1:"Seguro Medicall Home", texto2:"contratación con cargo mensual"},
        { url:"img/descuento.png", clase:"2", texto1:"20% de descuento", texto2:"primera compra en tiendas físicas*" },
        {url:"img/suitcase.png", clase:"2", texto1:"Descuentos en viajes", texto2:"Hasta 25% de descuento en Hoteles Grupo Ostar"},
        {url:"img/insurance.png", clase:"2", texto1:"Seguro para auto", texto2:"contratación con cargo mensual (Autotal Inbursa)"},
        {url:"img/fork.png", clase:"2", texto1:"10% de descuento", texto2:"en restaurantes y pastelerías (Sanborns y Sanborns Café)"},
        {url:"img/dollar.png", clase:"2", texto1:"Puntos Sears", texto2:"en todas tus compras con Crédito Revolvente" },
        {url:"img/rate.png", clase:"2", texto1:"25 días para pagar sin interés", texto2:"después de tu fecha de corte"},
        {url:"img/credit-cards-payment.png", clase:"1", texto1:"Tarjetas adicionales", texto2:"SIN COSTO"},
        {url:"img/gift-3.png", clase:"2",  texto1:"Recibe 100 puntos Sears", texto2:"al activar tu tarjeta Sears"},
        {url:"img/icon-tarjeta-sears.png", clase:"2", texto1:"Puedes comprar en:", texto2:"Sears y Sanborns"}
    ]

    const [activeData, setActiveData ] = useState(goldCard)
    useEffect(()=>{
        if(activeCard){
            if(activeCard === 'gold'){setActiveData(goldCard)}
            else if(activeCard === 'black'){setActiveData(blackCard)}
        }
    },[activeCard])

    return(
        <section className={`${styles?.sectionPromos} ${styles?.contanierSection}`}>
            <div className={styles?.cardPromos}>
                <p className={styles?.title}>Beneficios y promociones</p>
                <div className={styles?.contPromos}>
                    {activeData
                        ? activeData.map((dataCard, index) => 
                            <TarjetaDescuento key={index} url={dataCard?.url} type={dataCard?.clase} texto1={dataCard?.texto1} texto2={dataCard?.texto2}/>
                        )
                        : null
                    }
                </div>
                <div>
                    <div className={`${styles?.btn} ${styles?.white} ${styles?.arrow}`} onClick={sendCard}>Conoce más</div>
                </div>
            </div>
        </section>
    )
}

const SectionDescuentos = () => {

    const establecimientos = `https://buscador.ofertaspin.com/sears`

    return(
        <section className={`${styles?.sectionDiscount} ${styles?.contanierSection}`}>
            <div className={styles?.contDiscount}>
                <p><strong>Descuentos en prestigiados establecimientos</strong> a nivel nacional presentando tu tarjeta. <a href={establecimientos} target="_blank" > Ver establecimientos</a>
                </p>
            </div>
        </section>
    )
}

const SectionBeneficios = (props) => {

    const {
        activeCard,
        activePromo,
        setActivePromo
    } = props

    const history = useHistory()

    const sendCard = () => {
        const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`
        history.push(solicitaCredito)
    }

    const activeTabs = (e) => {
        const liElement = e.target;
        const liIndex = Array.prototype.indexOf.call(liElement.parentNode.children, liElement);
        setActivePromo(liIndex+1)
    }


    const childView = (index) => {
        document.querySelectorAll(`.${styles?.tabsTitles} li`).forEach(tab => tab.classList.remove(styles?.active))
        document.querySelectorAll(`.${styles?.tabsContent} li`).forEach(tab => tab.classList.remove(styles?.active))
        document.querySelectorAll(`.${styles?.tabsTitles} li`)[index-1].classList.add(styles?.active)
        document.querySelectorAll(`.${styles?.tabsContent} li`)[index-1].classList.add(styles?.active)
    }

    useEffect(() => {
        if(activePromo){
            childView(activePromo)
        }
    },[activePromo])

    useEffect(() => {
        if(activeCard){
            childView(1)
        }
    },[activeCard])

    return(
        <section className={`${styles?.sectionBeneficios} ${styles?.contanierSection}`}>
            <p className={styles?.h3}>Beneficios de tu Tarjeta <span>{activeCard}</span></p>

            <div className={styles?.contCards}>
                <div className={styles?.tabsCard}>
                    <ul className={styles?.tabsTitles} onClick={ (e) => activeTabs(e)}>
                        {activeCard === 'gold'
                            ?
                                <>
                                    <li><div className={styles?.primerCompIcon}>Primera compra</div></li>
                                    <li><div className={styles?.cumpleIcon}>Cumpleaños</div></li>
                                    <li><div className={styles?.vipIcon}>Cupón VIP</div></li>
                                </>
                            :
                                <>
                                    <li><div className={styles?.primerCompIcon}>Primera compra</div></li>
                                    <li><div className={styles?.cumpleIcon}>Cumpleaños</div></li>
                                    <li><div className={styles?.vipIcon}>Cupón VIP</div></li>
                                </>

                        }
                    </ul>
                    <ul className={styles?.tabsContent}>
                        {activeCard === 'gold'
                            ?
                                <>
                                    <li>
                                        <dl>
                                            <dt>20%*</dt>
                                            <dd>Muebles, Colchonería, Decoración, Alfombras, Home Nature, Equipaje, Cristalería y Vajillas, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Dulces y Chocolates, Discos y Videos, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Auto, Llantas, Centro Automotriz, Ropa, Calzado y Accesorios para Damas, Caballeros y Niños</dd>
                                        </dl>
                                        <dl>
                                            <dt>15%**</dt>
                                            <dd>Máquinas de coser y Aires Acondicionados, Calefacción Baños, Cocinas Integrales, Electrodomésticos, Artículos de Cocina. Deportes, Gourmet, Aparatos de Ejercicio, Ropa Deportiva</dd>
                                        </dl>
                                        <dl>
                                            <dt>10%**</dt>
                                            <dd>Muebles, Estufas, Hornos, Lavadoras y Secadoras, Refrigeradores, TV y Video y Sonido</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%*</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Médicas, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato</p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                        <p>** Adicional sobre precio rebajado</p>
                                                    </div>
                                                </Accordion>
                                            </dd>
                                        </dl>
                                    </li>

                                    <li>
                                        <dl>
                                            <dt>10%</dt>
                                            <dd>Máquinas de coser y aspiradoras, Estufas y Hornos, Lavadoras y Secadoras, Aire Acondicionado, Calefacción y Baños, Refrigeradores, Cocinas Integrales, Muebles, Colchonería, Decoracion, Alfombras, Home Nature, Electrodomésticos y Artículos para Cocina, Equipaje, Cristalería y Vajillas, Envoltura regalos, Deportes, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Gourmet, Dulces y Chocolates, Discos y Video, Aparatos de Ejercicio, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Autos, Llantas, Centro Automotriz, Ropa, Calzado y Accesorios para Damas, Caballeros y Niños</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%*</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Medics, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato</p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                    </div>
                                                </Accordion>
                                            </dd>
                                        </dl>
                                    </li>

                                    <li>
                                        <dl>
                                            <dt>10%</dt>
                                            <dd>Máquinas de coser y aspiradoras, Estufas y Hornos, Lavadoras y Secadoras, Aire Acondicionado, Calefacción y Baños, Refrigeradores, Cocinas Integrales, Muebles, Colchonería, Decoracion, Alfombras, Home Nature, Electrodomésticos y Artículos para Cocina, Equipaje, Cristalería y Vajillas, Envoltura regalos, Deportes, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Gourmet, Dulces y Chocolates, Discos y Video, Aparatos de Ejercicio, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Autos, Llantas, Centro Automotriz, Ropa, Calzado y Accesorios para Damas, Caballeros y Niños</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%*</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Medics, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato </p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                    </div>
                                                </Accordion> 
                                            </dd>
                                        </dl>
                                    </li>
                                </>
                            :
                                <>
                                    <li>
                                        <dl>
                                            <dt>25%*</dt>
                                            <dd>Muebles, Decoración, Alfombras, Home Nature, Equipaje, Cristalería y Vajillas, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Dulces y Chocolates, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Auto, Llantas, Centro Automotriz, Ropa y Accesorios para la Familia.</dd>
                                        </dl>
                                        <dl>
                                            <dt>20%*</dt>
                                            <dd>Máquinas de coser, Aire Acondicionado, Calefacción y Baños, Cocinas Integrales, Colchonería, Electrodomésticos, Deportes, Gourmet, Discos y Video, Aparatos de Ejercicio, Calzado para la Familia y Deportivo, Ropa Deportiva</dd>
                                        </dl>
                                        <dl>
                                            <dt>15%**</dt>
                                            <dd>Estufas, Hornos, Lavadoras y Secadoras, Refrigeradores</dd>
                                        </dl>
                                        <dl>
                                            <dt>10%**</dt>
                                            <dd>TV y Video y Sonido</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Médicas, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato</p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                        <p>** Adicional sobre precio rebajado</p>
                                                    </div>
                                                </Accordion>
                                            </dd>
                                        </dl>
                                    </li>
                                        
                                    <li>
                                        <dl>
                                            <dt>15%</dt>
                                            <dd>Máquinas de coser y aspiradoras, Estufas y Hornos, Lavadoras y Secadoras, Aire Acondicionado, Calefacción y Baños, Refrigeradores, Cocinas Integrales, Muebles, Colchonería, Decoracion, Alfombras, Home Nature, Electrodomésticos y Artículos para Cocina, Equipaje, Cristalería y Vajillas, Envoltura regalos, Deportes, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Gourmet, Dulces y Chocolates, Discos y Video, Aparatos de Ejercicio, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Autos, Llantas, Centro Automotriz, Ropa, Calzado y Accesorios para Damas, Caballeros y Niños</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%*</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Medics, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato</p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                    </div>
                                                </Accordion>
                                            </dd>
                                        </dl>
                                    </li>

                                    <li>
                                        <dl>
                                            <dt>10%</dt>
                                            <dd>Máquinas de coser y aspiradoras, Estufas y Hornos, Lavadoras y Secadoras, Aire Acondicionado, Calefacción y Baños, Refrigeradores, Cocinas Integrales, Muebles, Colchonería, Decoracion, Alfombras, Home Nature, Electrodomésticos y Artículos para Cocina, Equipaje, Cristalería y Vajillas, Envoltura regalos, Deportes, Vintage Home, Bazar Navideño, Juguetería, Juegos de Mesa y Collector, Artículos para Mascotas, Gourmet, Dulces y Chocolates, Discos y Video, Aparatos de Ejercicio, Blancos, Accesorios de Computación y Software, Fotografía, Ferretería, Jardinería, Accesorios Automotrices, Refacciones para Autos, Llantas, Centro Automotriz, Ropa, Calzado y Accesorios para Damas, Caballeros y Niños</dd>
                                        </dl>
                                        <dl>
                                            <dt>5%*</dt>
                                            <dd>Internet de las cosas</dd>
                                        </dl>

                                        <dl>
                                            <dt className={styles?.contIcon}><span className={styles?.exceptionIcon}></span></dt>
                                            <dd>
                                                <Accordion title={'Ver excepciones'} firstActive>
                                                    <p>Envoltura Regalos, Motocicletas, Computación, Telefonía, Tiempo Aire, Audio Portátil, Tabletas, Mercado Digital, Videojuegos, Apple-Itunes, Perfumería y Concesiones, Cocinas de precio especial, Alfombras sobre medida, Recubrimientos y las marcas: Tempur, Luuna, Nooze y Sognare, Apple, DJI, Amazon, Nespresso, Dolce Gusto, Levi´s, Dockers, Vitos y Ann Shantel, Wenger y Seiko, Inova, CV Directo, Marcas de Renombre y Home Medics, Prinsel, Evenflo, Avent, Chicco, Converse, Crocs, Skechers, Charly, Vans, Andrea, Ferrato </p>
                                                    <div className={styles?.terms}>
                                                        <p>* Aplica sobre precio regular</p>
                                                    </div>
                                                </Accordion> 
                                            </dd>
                                        </dl>
                                    </li>
                                </>
                        }
                    </ul>
                </div>
            </div>

            <div>
                <div className={`${styles?.btn} ${styles?.red}`} onClick={sendCard}>Solicítala hoy</div>
            </div>
        </section>
    )
}

const SectionExcepciones = (props) => {

    const {
        activePromo
    } = props

    let imagenesSlider = [
        { "id": 0, "url": "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/credito_banner1.jpg", "nombre": "imagen 1", "link": "", "target": "_self" },
        { "id": 1, "url": "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/Pago-Express.jpg", "nombre": "imagen 1", "link": "", "target": "_self" },
        { "id": 2, "url": "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/mailing-Sears clics 600x560px-01.jpg", "nombre": "imagen 2", "link": "https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&pa=P&pro=SEARS#no-back-button", "target": "_blank" },
        { "id": 3, "url": "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/restaurante_sanborns_1240x600_px.JPG", "nombre": "imagen 3", "link": "", "target": "_self" }
    ];

    const settings = {
        dots: true,
        dotsClass: styles?.dotsSliders,
        className: styles?.slideSliders,
        autoplay: true,
        infinite: true,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    autoplay: true,
                    infinite: true,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    return(
        <section className={`${styles?.sectionExcepciones} ${styles?.contanierSection}`}>

            

            <div className={styles?.contSilder}>
                <Slider {...settings}>
                    {imagenesSlider.map(({ url, id, enlace, nombre, link , target}) =>
                        <a href={link ? link : ""} title={nombre} key={id} className="cardSliderBeneficios" target={target}>
                            <img loading="lazy" src={url} alt={nombre} width="260" height="485" importance="low" />
                        </a>
                    )}
                </Slider>
            </div>
        </section>
    )
}

const SectionRequisitos = (props) => {
    
    const urlReq = "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/nuevoCredito/documents/SOLICITUD_CONTRATO_SEARS.pdf" 
    const urlCont = "https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/credito/nuevoCredito/documents/CONTRATO_APERTURA_DE_CREDITO_SEARS.pdf" 

    const requisitosList = [
        {title:'Ser mayor de edad.'},
        {title:'Llenar y firmar la solicitud de crédito, donde autoriza la investigación y consulta de su historial crediticio.'},
        {title:'Tener estabilidad en domicilio y empleo mínimo de 1 año; en caso contrario, proporcionar domicilio y/o empleo anterior.'},
        {title:'Contar con teléfono en domicilio, empleo (puede ser celular) y celular personal.'},
        {title:'Ingresos mensuales comprobables fijos de $7,000 o superior.'},
        {title:'Proporcionar 2 referencias familiares con teléfono y domicilio diferente al del solicitante.'},
        {title:'Deseable con una referencia bancaria o comercial.'},
        {title:'Correo electrónico (deseable)'},
        {title:'Identificación OFICIAL. La copia debe ser legible y que el rostro del solicitante sea visible.'},
    ]

    return(
        <section className={`${styles?.sectionRequisitos} ${styles?.contanierSection}`}>
            <div className={styles?.contReq}>
                <p className={`${styles?.h3} ${styles?.textRed}`}>Requisitos</p>
                <div className={styles?.contCards}>
                    <ul>
                        {requisitosList?.map((req, index ) => 
                            <li key={index}>{req?.title}</li>
                        )}
                    </ul>
                </div>
            </div>
            <div className={styles?.contReq}>
                <p className={styles?.h2}>Descargar</p>
                <div className={styles?.contCards}>
                    <dl>
                        <dt className={styles?.documentIcon}>
                            <a href={urlReq} className={styles?.textRed} target="_blank" title="Requisitos y Formato de solicitud">Requisitos y Formato de solicitud.</a>
                        </dt>
                    </dl>
                    <dl>
                        <dt className={styles?.documentIcon}>
                            <a href={urlCont} className={styles?.textRed} target="_blank" title="Contrato de Crédito Sears">Contrato de Crédito Sears.</a>
                        </dt>
                    </dl>
                </div>
            </div>
        </section>
    )
}

const BeneficiosNew = () => {

    const { flow } = useValidateAccount()
    const [ activeCard, setActiveCard ] = useState('gold')
    const [ activePromo, setActivePromo ] = useState(1)

    return (
        <>
            <div className={styles?.contHeadSMBeneficios}>
                <HeaderSubMenu />
            </div>

            <SectionCards
                activeCard={activeCard}
                setActiveCard={setActiveCard}
                flow={flow}
            />
            <SectionPromos
                activeCard={activeCard}
            />

            <SectionDescuentos />

            <SectionBeneficios
                activeCard={activeCard}
                activePromo={activePromo}
                setActivePromo={setActivePromo}
            />

            <SectionExcepciones 
                activePromo={activePromo}
            />

            <SectionRequisitos />
        </>
    )
}  

export default BeneficiosNew